var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0114 15.5203L24.0114 15.5203L24.0128 15.519L24.2404 15.3038L24.5095 15.0494L24.2404 14.7951L24.0128 14.5798L24.0128 14.5798L24.0114 14.5786L17.0293 8.04732L17.0282 8.0463L16.8081 7.8422L16.5582 7.6105L16.3199 7.85405L15.8987 8.28451L15.6473 8.54147L15.9109 8.78593L16.13 8.98909L16.131 8.99003L21.9215 14.4025L7.47433 14.4025L7.17076 14.4025L6.82076 14.4025L6.82076 14.7525L6.82076 15.3463L6.82076 15.6963L7.17076 15.6963L7.47433 15.6963L21.9219 15.6963L16.1348 21.1088L16.1337 21.1098L15.9147 21.3129L15.6523 21.5562L15.9014 21.8132L16.3188 22.2436L16.5571 22.4894L16.8081 22.2566L17.0282 22.0525L17.0282 22.0525L17.0293 22.0515L24.0114 15.5203Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/arrow-icon.1415f2c95e4621355fb5f939950671c5.svg";
export { ForwardRef as ReactComponent };